import { useQuery } from '@tanstack/react-query';
import { fetchAdminAnalytics, type AdminAnalyticsResponse } from '../api/adminAnalytics';

export function useAdminAnalytics() {
  return useQuery<AdminAnalyticsResponse>({
    queryKey: ['admin-analytics'],
    queryFn: () => fetchAdminAnalytics(),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  });
}
